import React from 'react'

function TextDescription(props) {
  return (
    <div>{props.label}</div>
  )
}

export default TextDescription